import "whatwg-fetch";

const handleCatch = (error, errorCallback) => {
  errorCallback(error);
};
const handleData = (response, errorCallback) => {
  if (!response || !response.ok || response.status >= 400)
    errorCallback(response);
  else return response.json();
};
const handleResponse = (response, errorCallback, successCallback) => {
  if (!response || response.success === false) errorCallback(response);
  else successCallback(response);
};

const endpoints = {
  REACT_APP_API_URL: "http://localhost:4000",
  REACT_APP_API_URL_PROD: "http://46.101.119.208",
};

export const call = (url, data, successCallback, errorCallback) => {
  const headers = new Headers({
    Accept: "application/json",
    "Content-Type": "application/json",
  });
  const requestDetails = Object.assign({}, data, { headers: headers });

  const baseUrl =
    process.env.NODE_ENV === "development"
      ? endpoints.REACT_APP_API_URL
      : endpoints.REACT_APP_API_URL_PROD;

  fetch(`${baseUrl}${url}`, requestDetails)
    .catch((error) => handleCatch(error, errorCallback))
    .then((response) => handleData(response, errorCallback))
    .then((response) =>
      handleResponse(response, errorCallback, successCallback)
    );
};



// WEBPACK FOOTER //
// ./src/api/call.js